import { useEmployments } from '@builddocs/data-management'
import { Badge, Box, Tooltip } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import {
  usePopupState,
  bindTrigger,
  bindPopover,
} from 'material-ui-popup-state/hooks'

import NotificationsIcon from '../../public/icons/notification.svg'

import { EmploymentPopover } from './EmploymentPopover'

interface OwnProps {
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
}

export type EmploymentButtonProps = OwnProps

export const EmploymentButton = ({
  placement = 'bottom',
}: EmploymentButtonProps) => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'popover-notifications',
  })

  const { unreadCount, setUnreadCount } = useEmployments()

  const bindPopoverProps = bindPopover(popupState)

  return (
    <Box>
      <Tooltip placement={placement} title="Уведомления">
        <IconButton
          {...bindTrigger(popupState)}
          sx={{
            p: 0.55,
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          }}
        >
          <Badge
            badgeContent={unreadCount}
            color="primary"
            sx={{
              width: 32,
              height: 32,
              justifyContent: 'center',
              alignItems: 'center',
              '& .MuiBadge-badge': {
                right: 4,
                top: 6,
              },
            }}
          >
            <Box alt="Уведомления" component="img" src={NotificationsIcon} />
          </Badge>
        </IconButton>
      </Tooltip>
      <EmploymentPopover
        popoverProps={bindPopoverProps}
        setUnreadCount={setUnreadCount}
      />
    </Box>
  )
}
